/* eslint-disable react/react-in-jsx-scope */
import { useTranslation } from 'react-i18next'
import Heading from '../Heading/Heading'
import Text from '../Text'
import { TYPES_MENU_LIST } from '../../constants/menu'

const LegalNotice = () => {
  const { t } = useTranslation()

  return (
    <div id={t(TYPES_MENU_LIST.LEGAL_NOTICE)}>
      <Heading level={2}>
        {t('Aviso legal y condiciones generales de acceso y uso')}
      </Heading>
      <Heading level={3}>
        {t('Propiedad de la página web y su contenido')}
      </Heading>
      <Text>
        {t(
          'EDITORIAL VICENS VIVES, S.A.U. (en adelante, VICENS VIVES), con NIF A-08375545, domiciliada en Vía Augusta, 260, Local B, 08017 de Barcelona, en cumplimiento de las obligaciones dispuestas en la Ley 34/2002, de 11 de julio, de Servicios de la Sociedad de la Información y de Comercio Electrónico (LSSICE), BOE N º 166, informa a los Usuarios de los servicios y aplicaciones ofrecidos por VICENS VIVES en las webs bajo los siguientes dominios'
        )}{' '}
        (
        <a
          href='http://www.vicensvives.com'
          rel='noopener noreferrer'
          target='_blank'
        >
          vicensvives.com
        </a>
        ,{' '}
        <a
          href='http://www.vicensvivesdigital.com'
          rel='noopener noreferrer'
          target='_blank'
        >
          vicensvivesdigital.com
        </a>
        ,{' '}
        <a
          href='http://www.vicensvives.com.co'
          rel='noopener noreferrer'
          target='_blank'
        >
          vicensvives.com.co
        </a>
        ,{' '}
        <a
          href='http://www.vicensvives.cl'
          rel='noopener noreferrer'
          target='_blank'
        >
          vicensvives.cl
        </a>
        ,{' '}
        <a
          href='http://www.vicensvives.com.mx'
          rel='noopener noreferrer'
          target='_blank'
        >
          vicensvives.com.mx
        </a>
        ,{' '}
        <a
          href='http://www.vicensvives.com.pe'
          rel='noopener noreferrer'
          target='_blank'
        >
          vicensvives.com.pe
        </a>
        ,{' '}
        <a
          href='http://www.vicensvives.com.ar'
          rel='noopener noreferrer'
          target='_blank'
        >
          vicensvives.com.ar
        </a>
        ,{' '}
        <a
          href='http://www.vvkids.com'
          rel='noopener noreferrer'
          target='_blank'
        >
          vvkids.com
        </a>
        ){' '}
        {t(
          'en adelante los SERVICIOS VICENS VIVES, de sus Condiciones de Acceso y Uso.'
        )}
      </Text>
      <Text>
        {t(
          'El acceso y utilización a cualquier página web titularidad de VICENS VIVES supone la aceptación plena y sin reservas por parte del Usuario de las presentes Condiciones Generales de Acceso y Uso vigentes en cada momento en que el Usuario acceda a cualquiera de las citadas páginas web. Estas Condiciones Generales, por tanto, regulan el acceso y uso de los sitios web que VICENS VIVES pone gratuitamente a disposición de los Usuarios de Internet. La utilización de determinados servicios ofrecidos en alguno de los sitios web de servicios VICENS VIVES se pueden regir además por condiciones particulares previstas en cada caso, las cuales se entenderán aceptadas por el mero uso de tales servicios.'
        )}
      </Text>
      <Text>
        {t(
          'Cuando el usuario accede a los sitios web de VICENS VIVES confirma haber leído el presente Aviso Legal.'
        )}
      </Text>
      <Text>
        {t(
          'VICENS VIVES no garantiza que los contenidos de sus Páginas sean aptos o disponibles fuera de España. En el supuesto de que todo o parte de los contenidos de las Páginas de VICENS VIVES sean considerados ilegales en países distintos a España, queda prohibido el acceso a los mismos.'
        )}
      </Text>
      <Heading level={3}>{t('Propiedad intelectual e industrial')}</Heading>
      <Text>
        {t(
          'Los sitios web de VICENS VIVES se rigen por las leyes españolas y están protegidos por la legislación nacional e internacional sobre Propiedad Intelectual e Industrial.'
        )}
      </Text>
      <Text>
        {t(
          'Los Derechos de Propiedad Intelectual e Industrial sobre toda la información contenida en sitios web de VICENS VIVES, entre otros, diseño gráfico, dibujos, logotipos, imágenes, índices, textos, audios, vídeos, software, diseño y signos identificativos,  así como sus códigos fuente, estructura de navegación, bases de datos, y todos los elementos en ellos contenidos, son titularidad de VICENS VIVES excepto aquellos contenidos que pertenecen a terceros al que el Usuario puede acceder a través de hipervínculos.'
        )}
      </Text>
      <Text>
        {t(
          'En ningún caso el acceso y uso a las Páginas web SERVICIOS VICENS VIVES por parte de los Usuarios, se podrá considerar como que se concede licencia de uso, o derecho a ningún activo de VICENS VIVES o sus autores legítimos, por lo que no implicará una cesión, ni transmisión o cualquier tipo de renuncia de derechos de Propiedad Intelectual y/o Industrial.'
        )}
      </Text>
      <Text>
        {t(
          'Corresponde a VICENS VIVES el ejercicio exclusivo de los derechos de explotación de los contenidos de sus sitios web en cualquier forma y, en especial, los derechos de reproducción, distribución, comunicación pública y transformación.'
        )}
      </Text>
      <Text>
        {t(
          'Queda prohibida toda reproducción, copia, distribución transformación, publicación y cualquier otra actividad que pueda realizarse con la información contenida en las páginas web de los SERVICIOS VICENS VIVES, así como con su diseño y la selección y modelo de presentación de los materiales incluidas en ellas, para cualquier fin y medio utilizado, sin la autorización expresa de VICENS VIVES o el autor legítimo.'
        )}
      </Text>
      <Text>
        {t(
          'La utilización no autorizada de la información contenida en las páginas web de los SERVICIOS VICENS VIVES, su modificación o supresión de datos, así como la lesión de los Derechos de Propiedad Intelectual o Industrial de VICENS VIVES dará lugar a las responsabilidades legalmente establecidas.'
        )}
      </Text>
      <Heading level={3}>{t('Exoneración de responsabilidad')}</Heading>
      <Text>
        {t(
          'Todos los Usuarios de estos sitios web lo hacen bajo su propio riesgo, y al acceder a ellos aceptan utilizarlo según las leyes y usos de tráfico y deberán responder ante VICENS VIVES u otras empresas, por cualquier daño que pueda haber sido producido como resultado de un incumplimiento de estas obligaciones.'
        )}
      </Text>
      <Text>
        {t(
          'Tanto el acceso a los sitios web de los SERVICIOS VICENS VIVES como el uso que pueda hacerse de la información contenido en los mismos es de la exclusiva responsabilidad de quien lo realiza. VICENS VIVES no responderá de ninguna consecuencia, daño o perjuicio que pudieran derivarse del acceso o uso de dicha información. '
        )}
      </Text>
      <Text>
        {t(
          'VICENS VIVES no se responsabiliza de los posibles errores de seguridad que puedan producirse ni de cualquier daño o perjuicio que pueda causarse al sistema informático del Usuario, los ficheros o documentos almacenados en el mismo como consecuencia del acceso a las Páginas web de los SERVICIOS VICENS VIVES o del uso de información o aplicaciones en ella contenidas.'
        )}
      </Text>
      <Text>
        {t(
          'VICENS VIVES no asume responsabilidad alguna derivada de la concesión o contenidos de los enlaces de terceros a los que se hace referencia en sus sitios web o que terceras partes hayan incluido en los hipervínculos. El establecimiento del hipervínculo no implica en ningún caso la existencia de relaciones entre VICENS VIVES y el propietario de la página Web en la que se establezca, ni la aceptación y aprobación de sus contenidos o servicios allí ofrecidos. Asimismo, VICENS VIVES no garantiza la ausencia de virus u otros elementos que puedan producir alteraciones en el sistema informático, los documentos o los ficheros del Usuario, excluyendo cualquier responsabilidad por los daños de cualquier clase causados al Usuario derivado del acceso a estos enlaces de terceros.'
        )}
      </Text>
      <Heading level={3}>
        {t('Modificaciones y acceso a los servicios')}
      </Heading>
      <Text>
        {t(
          'VICENS VIVES se reserva el derecho a efectuar, sin previo aviso, las modificaciones que considere oportunas en la página Web, pudiendo cambiar, suprimir o añadir tanto contenidos y servicios que se presten a través de la misma, como la forma en la que éstos aparezcan presentados o localizados.'
        )}
      </Text>
      <Text>
        {t(
          'VICENS VIVES pondrá sus mayores esfuerzos en mantener actualizada y libre de errores la información contenida en la Web, pero no ofrece garantía alguna respecto de su exactitud y puesta al día. Tampoco está garantizada la obtención de ningún resultado o fin concreto, por lo que el acceso y utilización de la Web es de exclusiva responsabilidad de los usuarios.'
        )}
      </Text>
      <Text>
        {t(
          'VICENS VIVES no garantiza que el acceso sea ininterrumpido o libre de errores, quedando exonerada de cualquier responsabilidad por daños derivados del uso o imposibilidad de uso (incluyendo todos los daños indirectos, como la pérdida de beneficios, oportunidades de negocio, de información, etc.).'
        )}
      </Text>
      <Heading level={3}>{t('Protección de datos')}</Heading>
      <Text>
        {t(
          'VICENS VIVES informa a los usuarios de los SERVICIOS VICENS VIVES que es el Responsable del tratamiento de los datos de carácter personal recabados a través de los citados servicios.'
        )}
      </Text>
      <Text>
        {t(
          'De conformidad con lo establecido en la legislación aplicable en materia de protección de datos, VICENS VIVES respeta la privacidad de los Usuarios y el secreto y seguridad de los datos personales, adoptando para ello las medidas técnicas y organizativas necesarias para evitar la pérdida, mal uso, alteración, acceso no autorizado y robo de los datos personales facilitados, habida cuenta el estado de la tecnología, la naturaleza de los datos y los riesgos a los que están expuestos.'
        )}
      </Text>
      <Text>
        {t(
          'Los datos personales de los Usuarios de los sitios web de los SERVICIOS VICENS VIVES, solo se obtendrán para ser tratados cuando sean adecuados, pertinentes y no excesivos en relación con el ámbito y las finalidades determinadas, explícitas, consentidas y/o legítimas para las que se hayan recabado. Cuando se recaben datos personales a través de los sitios webs de los SERVICIOS VICENS VIVES, se informará previamente al Usuario de forma clara e inequívoca de las circunstancias relativas al tratamiento de sus datos.'
        )}
      </Text>
      <Text>
        {t('El Usuario deberá visitar la')}{' '}
        <a href={`#${t(TYPES_MENU_LIST.PRIVACY_POLICY)}`}>
          {t('Política de Privacidad')}
        </a>{' '}
        {t(
          'de VICENS VIVES donde encontrará información detallada respecto a la protección de datos.'
        )}
      </Text>
      <Heading level={3}>{t('Legislación aplicable')}</Heading>
      <Text>
        {t(
          'Todas las cuestiones relativas a los SERVICIOS VICENS VIVES se regirán por la legislación española. VICENS VIVES y los Usuarios, con renuncia expresa a cualquier otro fuero, se someten a la jurisdicción de los Juzgados y Tribunales de Barcelona.'
        )}
      </Text>
      <Text>
        {t(
          'Toda la información que se reciba en las páginas web de los SERVICIOS VICENS VIVES se considerará cedida a VICENS VIVES a título gratuito.'
        )}
      </Text>
      <Text>
        {t(
          'A los efectos de presentación de cualquier reclamación, consulta o sugerencia, se pone a disposición el siguiente correo electrónico'
        )}
        : <a href='mailto:legal@vicensvives.com'>legal@vicensvives.com</a>
      </Text>
    </div>
  )
}

export default LegalNotice
